export default {
    id: "personal-support-2026",
    articleType: "release",
    slug: "personalnoe-soprovozhdenie-na-platforme",
    date: "12 мая 2026",
    dateTime: "2026-05-12",
    modifiedTime: "2026-05-12",
    author: "Редакция «Светофор Логистика»",
    category: "Сервис · 2026",
    contentType: "Команда",
    title: "Персональное сопровождение пользователей: знакомьтесь, Никита",
    sidebarTitle: "Персональное сопровождение пользователей",
    seoTitle:
        "Персональное сопровождение пользователей «Светофор Логистика»",
    seoDescription:
        "В команде «Светофор Логистика» появился ведущий специалист отдела внедрений и сопровождения, который помогает пользователям осваивать и настраивать платформу.",
    image:
        "/img/news/personalnoe-soprovozhdenie-na-platforme/cover.webp",
    imageAlt:
        "Никита, ведущий специалист отдела внедрений и сопровождения «Светофор Логистика»",
    content: {
        subtitle:
            "В команде появился ведущий специалист отдела внедрений и сопровождения",
        lead: [
            "Переход на новую цифровую платформу требует времени: даже полезные функции не работают на бизнес, если пользователю сложно разобраться в настройках и сценариях.",
            "Поэтому в команде «Светофор Логистика» появился Никита — ведущий специалист отдела внедрений и сопровождения.",
        ],
        sections: [
            {
                icon: "👋",
                title: "Задача персонального сопровождения",
                paragraphs: [
                    "Главная задача Никиты — помочь пользователям настроить платформу под реальные рабочие процессы и использовать её возможности в ежедневной логистике.",
                ],
            },
            {
                icon: "🧭",
                title: "Чем может помочь Никита",
                items: [
                    {
                        title: "Обучение с нуля",
                        text: "Покажет основные сценарии работы и поможет настроить кабинет под задачи компании.",
                    },
                    {
                        title: "Разбор функций",
                        text: "Расскажет о возможностях платформы, включая временные окна и другие инструменты автоматизации.",
                    },
                    {
                        title: "Оперативная поддержка",
                        text: "Поможет разобраться с вопросами по использованию платформы и подобрать рабочий сценарий.",
                    },
                ],
            },
            {
                icon: "🤝",
                title: "Технологии и люди",
                paragraphs: [
                    "Для нас ИТ-платформа — это не только код, но и команда, которая помогает пользователям внедрять цифровые инструменты в реальную работу.",
                ],
            },
        ],
    },
};
